<template>
  <div>
    <div class="aiandface" style="width: 350px; margin: 0 auto">
      <!--视频标签-->
      <div
        class="canvas-video"
        id="face-video"
        v-show="
          !windowParam.isWindows &&
          v2cParam.videoForm &&
          !windowParam.isWindowsFull
        "
      >
        <!-- <div class="video-box" v-drag> -->
        <div class="video-box">
          <video
            id="inputVideo"
            autoplay
            muted
            playsinline
            width="350"
            height="230"
            style="border-radius: 10px"
          ></video>
          <canvas
            id="overlay"
            v-show="v2cParam.videoOpen"
            width="350"
            height="230"
            style="background-color: transparent"
          ></canvas>
          <div class="distgrid" v-if="v2cParam.videoloading">
            <div class="wgrid"></div>
            <span
              style="
                position: absolute;
                z-index: 1;
                color: #fff;
                transform: scaleX(-1);
                right: 0;
                text-align: center;
                top: 308px;
                display: block;
                width: 100%;
                font-size: 30px;
              "
              >视频数据解析中</span
            >
          </div>

          <div
            class="video-back"
            v-if="!v2cParam.videoOpen"
            style="background-color: rgb(30 30 30)"
          >
            <div class="back-btn">
              <i class="iconfont icon-renlianshibie"></i>
            </div>
          </div>
        </div>

        <div
          class="video-fps"
          v-show="v2cParam.fps >= 1"
          :class="{
            good: v2cParam.fps >= 8,
            success: v2cParam.fps >= 12 || v2cParam.fps == 0,
            bad: v2cParam.fps < 8 && v2cParam.fps > 0,
          }"
        >
          <div class="fts">
            <span v-if="v2cParam.fps >= 12">正常({{ v2cParam.fps }})</span
            ><span
              v-if="v2cParam.fps != 0 && v2cParam.fps >= 8 && v2cParam.fps < 12"
              >性能不足({{ v2cParam.fps }})</span
            ><span v-if="v2cParam.fps != 0 && v2cParam.fps < 8"
              >性能严重不足({{ v2cParam.fps }})</span
            >
          </div>
        </div>

        <div class="video-btn" v-show="!isFirstOpen" @click="videoOpenClose">
          {{ v2cParam.faceloaded ? "启动中..." : "开启摄像头-动作捕捉" }}
        </div>

        <div class="v2cloading" v-if="!modelloading && faceinitloading">
          <img
            src="@/assets/images/20130527034916434.gif"
          /><br />动捕系统初始化中
        </div>
        <!-- 按钮组 -->
        <div>
          <ul class="bom_btn" style="">
            <li
              v-tooltip="{ content: '开始动捕' }"
              v-show="!isFirstOpen"
              @click="videoOpenClose"
            >
              <i class="iconfont icon-weibiaoti518"></i>
            </li>
            <li
              v-show="isFirstOpen"
              v-tooltip="{ content: '结束动捕' }"
              @click="closeVideo"
            >
              <i class="iconfont icon-weibiaoti517"></i>
            </li>
            <li
              v-tooltip="{
                content: '切换面部捕捉',
              }"
              v-show="aioption.body_pose"
              @click="changeWay()"
            >
              <i class="iconfont icon-rentijiance"></i>
            </li>
            <li
              v-show="!aioption.body_pose"
              v-tooltip="{
                content: '切换半体捕捉',
              }"
              @click="changeWay()"
            >
              <i class="iconfont icon-yonghuming"></i>
            </li>
            <li @click="jiaozhun()"><i class="iconfont icon-shuaxin"></i></li>
            <li v-tooltip="{ content: '设置' }" @click="isShowSet = !isShowSet">
              <i class="iconfont icon-shezhi"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 性能不足提示 -->
    <div
      v-if="v2cParam.winshow && !windowParam.isWindowsFull"
      style="width: 80%;background: #e5425b;    color: #fff;    position: fixed;    z-index: 99;    left: 10%;    padding: 15px;    text-align: center;
    border-radius: 0 0 20px 20px; top:0;   font-size: 16px;}"
    >
      <i class="iconfont icon-gantanhao"></i> 【计算机性能严重不足!】
      请关闭其它全部非必要应用程序再试!
      <a target="_blank" href="https://t-9.cn/news/1519628992116822016"
        >查看帮助</a
      >
      <span @click="v2cParam.winshow = false"
        >【<i class="iconfont icon-guanbi"></i>】</span
      >
    </div>
    <!-- 面部设置弹窗 -->
    <div class="setting setup" id="setup" v-if="isShowSet">
      <div class="set_content">
        <div class="tab-content">
          <div class="menu tab_action tab_bg">
            <div class="backtop">
              <span class="btncenter">设置</span>
              <div @click="isShowSet = false" class="chatbox_close">
                <i class="iconfont icon-guanbi"></i>
              </div>
            </div>
            <TabFace :user="user" @videoSelect="videoSelect" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var mycv
import { dataURLtoBlob, localData, asyncLoadJs, getRole, validate, getUserConfig } from '@/components/util/util_fun.js'

export default {
  name: 'face',
  data () {
    return {
      aioption: { //可配置参数
        rate: 30,//AI分析频率，每秒识别次数，建议（15-30）
        inputSize: 160, //识别使用的图片尺寸，越大性能越低，人站的越远，这个数要求越大
        scoreThreshold: 0.5,//数据置信度要求，因使用微型模型，别超过0.7
        eye_sensitivity: 1.5, //一般在0.1-0.4之间
        eye_iris: true,
        body_pose: false,
      },
      v2cParam: {
        faceJSloading: true,//面捕预热加载
        videoForm: true,//面捕窗口
        videoOpen: false,//面捕状态是否开启
        videoloading: false,//面捕loading
        logTips: "",//加载日志
        fps: 0,//帧率
        faceloaded: false,
        xingneng: [],//用于存储当前性能集合
        winshow: false //是否需要在页面上显示性能提示
      },
      windowParam: {//窗口模式下的参数
        isWindows: false,//是否为窗口electron模式
        isWindowsFull: false,//窗口程序的全屏,
      },
      isFirstOpen: false,//开始面捕按钮显示隐藏
      modelloading: false,//模型loading
      faceinitloading: false,//面捕初始化loading
      isShowSet: false, //面捕设置弹出层
      userconfig: getUserConfig(),//用户的配置信息
      xingneng: { //性能计算
        count: 0, starttime: 0
      },
      v2cobj: {},//面捕输入参数
      v2cOutParam: {},//t9输出参数
      videoEl: null
    }
  },
  props: {
    user: {
      type: Object,
      default: () => { { } }
    },
  },
  components: {
    TabFace: () => import(/*webpackChunkName:"TabFace"*/'./faceChild.vue'),
  },
  mounted () {
    // 这是人脸的点点
    mycv = document.getElementById('overlay')
  },
  beforeDestroy () {
    if (this.v2cParam.videoOpen) {
      // console.log('离开面捕页面---面捕关闭')
      this.closeVideo() // 离开页面时缓存已经初始化的摄像头捕捉,关闭摄像头

    }
    if (window.face2ctoo) {
      window.face2ctoo = undefined
    }
  },
  created () {
    this.initFaceVideo() //初始化面捕系统,
  },
  methods: {
    /**
  * 面捕结束后，回复原有动画
  */
    restartAnimation () {
      // console.log("面捕结束")
      t9render.runfunction("captureend")

    },
    //面捕的重置校准功能，动作捕捉不需要校准
    jiaozhun () {
      this.v2cParam.videoloading = true

      // if (t9render) {
      //   t9render.calibration() //2D模型重置
      // }
      face2ctoo.calibration() //面捕重置

      this.$message.success("校准成功！")
      this.v2cParam.videoloading = false

    },
    // 切换面捕/动捕
    changeWay () {
      if (!this.v2cParam.videoOpen) return this.$message.warning("请打开摄像头！")
      this.userconfig = getUserConfig()
      if (this.userconfig.motioncap == '1') {
        // console.log('当前是动捕,切换为面捕')
        this.setconfig('motioncap', '0')
        this.aioption.body_pose = false
      } else {
        this.faceinitloading = true
        this.actionLoading = true
        console.log('当前是面捕,切换为动捕')
        this.setconfig('motioncap', '1')
        this.aioption.body_pose = true
      }
      if (this.v2cParam.videoOpen) {
        // console.log('切换执行')
        face2ctoo.option(this.aioption)

      }
    },
    setconfig (name, newValue) { //保存用户习惯方法
      // console.log(name,newValue);
      this.userconfig[name] = newValue
      localData("set", "userconfig", this.userconfig)
      t9render.sendmsg({ type: "userconfig", data: this.userconfig })
    },
    //   关闭摄像头
    closeVideo () {
      this.v2cParam.faceloaded = false
      this.v2cParam.videoOpen = false
      window.face2ctoo.face_stop()
      //暂停摄像头
      var thisVideo = document.getElementById("inputVideo")
      if (thisVideo && thisVideo.srcObject != undefined) {
        var trackList = thisVideo.srcObject.getTracks()
        if (trackList.length > 0) {
          for (let index = 0; index < trackList.length; index++) {
            if (trackList[index].readyState == "live") {
              trackList[index].stop()
            }
          }
        }
      }
      // thisVideo.srcObject = null

      // 显示开始面捕按钮
      this.isFirstOpen = false
      this.v2cParam.fps = 0

      this.restartAnimation()
    },
    //摄像头change事件，未打开时触发()
    videoSelect (deviceId) {
      // console.log('子组件携带相机id', deviceId)
      this.setconfig("camera", deviceId)//保存到用户习惯
      // this.ws.sendMsg(104, "切换摄像头", deviceId)

      if (!this.windowParam.isWindows && this.v2cParam.videoOpen) {

        window.face2ctoo.face_stop()
        var videoObj = { "video": true }
        if (deviceId != "") {

          //切换摄像头
          videoObj = { "video": { deviceId: deviceId } }
        }

        const videoEl = document.getElementById("inputVideo")

        var that = this
        navigator.mediaDevices.getUserMedia(videoObj).then(function (stream) {

          videoEl.srcObject = stream
          videoEl.onloadeddata = async function () {
            videoEl.play()
            that.getFacePoint()
          }
        })
      }
    },

    //打开或关闭面捕
    videoOpenClose () {
      // console.log('点击打开或关闭面捕')
      // 移动到开启面捕时进行初始化
      //初始化面捕系统
      if (!this.windowParam.isWindows && window.face2ctoo == undefined) {
        //初始化面捕
        this.initFaceVideo()
      } else {
        this.v2cParam.faceJSloading = false
      }
      this.v2cParam.faceloaded = true//启动中
      this.beginGetVideoFace()

    },


    //初始面捕
    initFaceVideo () {
      // console.log('进入初始化面捕')
      this.faceinitloading = true

      // console.log('face2ctoo参数', window.face2ctoo)
      //实例化动作捕捉
      if (window.face2ctoo == undefined) { //如果没有实例化，就实例化
        window.face2ctoo = new v2c.t9f.T9_face2C(this.aioption)

      }

      var that = this


      if (this.userconfig.motioncap == 1) {  //默认启动为面捕
        this.userconfig.motioncap = '0'
        this.setconfig('motioncap', '0')
        face2ctoo.option({ body_pose: false })
        this.aioption.body_pose = false

      }
      else {
        this.aioption.body_pose = false
        face2ctoo.option({ body_pose: false })
      }
      //读取模型（预热数据）
      face2ctoo.modeload().then(function () {
        that.faceinitloading = false
        // console.log("加载完成")
        that.v2cParam.faceJSloading = false
      }).catch(function (e) {
        that.v2cParam.faceJSloading = false
        that.$message.error("警告：面捕加载异常！")
      })

    },

    /**
     * 开始面捕
     */
    beginGetVideoFace () {
      console.log('开始面捕beginGetVideoFace')

      //electron模式下
      if (this.windowParam.isWindows) {
        return
      }
      var that = this


      //web模式
      this.v2cParam.faceloaded = true //摄像头loading
      this.v2cParam.videoloading = true //识别loading
      var date = new Date()
      // console.log("开始加载摄像头:【" + date.getMinutes() + ":" + date.getSeconds() + "】")



      this.videoEl = document.getElementById("inputVideo")
      console.dir(this.videoEl)

      var videoObj = { "video": true }
      if (this.userconfig.camera != '') { //如果多个摄像头，并做出了选择
        //切换摄像头
        videoObj = { "video": { deviceId: this.userconfig.camera } }
      }

      navigator.mediaDevices.getUserMedia(videoObj).then((stream) => {
        console.log('获取摄像头成功', this.videoEl)
        this.videoEl.srcObject = stream
        this.videoEl.onloadeddata = () => {

          this.videoEl.play()
          this.v2cParam.videoOpen = true
          this.isFirstOpen = true
          setTimeout(() => {

            this.getFacePoint()

          }, 100)

        }

      }).catch(function (err) {

        that.v2cParam.videoOpen = false
        that.v2cParam.faceloading = false
        that.v2cParam.videoloading = false
        if (err.name == "NotAllowedError") {
          that.$message.warning("请允许当前浏览器使用摄像头，否则无法开启面捕！")
        } else if (err.name == "NotReadableError") {
          that.$message.warning("请检查摄像头是否被其他设备占用！")
        } else {
          that.$message.warning("摄像头启动失败，请检查设备是否可用！" + err)
        }

      })

    },

    //开始拉取面捕数据
    getFacePoint () {

      // t9render.updatet9db(JSON.parse(this.user.param).t9live2d);  
      // var date = new Date()
      // const videoEl = document.getElementById("inputVideo");
      // console.log("开始分析数据:【" + date.getMinutes() + ":" + date.getSeconds() + "】")

      //获得面捕数据
      console.log('开始拉取面捕数据', this.videoEl, this.myfacel, mycv)
      face2ctoo.getlanmarks(this.videoEl, this.myfacel, mycv)
    },

    //重新初始化面捕数据。关闭摄像头后避免面孔扭曲
    initFaceData () {
      var v2cobj = {
        // crooked: 0,
        // eye_left: 10,
        // eye_right: 10,
        // eyebrow_left: 0,
        // eyebrow_right: 0,
        // face: [0,0],
        // iris_x: 0,
        // iris_y: 0,
        // mouth_height: 0,
        // mouth_width: 0,
      }

      t9render.bindAnimation(v2cobj)
      this.myfacel(v2cobj, "close")
    },

    xingnengtest () {

      var starttimed = this.xingneng.starttime
      if (starttimed == 0) {
        starttimed = new Date()
        this.xingneng.starttime = starttimed
      }

      let usedTime = new Date() - starttimed // 相差的毫秒数

      if (usedTime > 1000) //运行一秒了
      {
        this.v2cParam.fps = this.xingneng.count
        this.v2cParam.xingneng.push(this.xingneng.count) //记录性能
        if (this.v2cParam.xingneng.length >= 10) {
          this.v2cParam.xingneng.shift()//移除第一个数据
        }
        //筛选性能比较低的值有多少
        var xnbl = this.v2cParam.xingneng.filter(function (xn) {
          return xn <= 8
        })
        if (xnbl.length > 5)//如果超出5个，就要提示
        {
          this.v2cParam.winshow = true
        }
        else {
          this.v2cParam.winshow = false
        }
        // console.log(this.v2cParam.fps);
        this.xingneng.count = 0
        this.xingneng.starttime = new Date()
      }
      else {
        this.xingneng.count++
      }


    },

    //面捕回调
    myfacel (v2cobj, faceLandmarks) {
      console.log('面部回调', v2cobj, faceLandmarks)
      if (this.faceinitloading && this.aioption.body_pose) {
        this.faceinitloading = false
        this.actionLoading = false
      }
      //这是用于计算FTS性能
      this.xingnengtest()

      // t9render.updatet9db();
      // console.log(v2cobj);
      if (typeof (v2cobj) == "string") {
        console.log("v2c出现异常，重新加载：" + v2cobj)
        this.$message.warning("动作捕捉系统错误！")
        this.getFacePoint()
      }
      else if ((v2cobj && (this.v2cParam.videoOpen || this.windowParam.isWindows)) || faceLandmarks == "close") {

        this.v2cobj = v2cobj //用于实时显示参数


        t9render.runfunction("bindAnimation", [v2cobj])
        //这是空间移动，暂时不需要
        // if(faceLandmarks&&this.aioption.position){
        //     this.$emit("faceChange",faceLandmarks)
        // }

        //获得人脸数据后，将loading关掉
        if (this.v2cParam.faceloaded) {
          this.v2cParam.faceloaded = false
          this.v2cParam.videoloading = false
          //     this.$message.success("校准成功！");
          // if (this.user.type == 3 || this.user.type == 4) { //3D类型
          //   this.t93d.calibration()
          // } else { //2D 类型
          //   this.t9render.stopAnimation()
          // }
        }


        // this.v2cParam.fps=PixiCommon.getTickerFPS();
      } else {
        //未找到人
        // console.log('v2cobj', v2cobj)
        // console.log('this.v2cParam.videoOpen', this.v2cParam)
        // console.log('this.windowParam.isWindows', this.windowParam)
        // console.log("未找到人")
      }

    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
#face-video {
  @include border_color("bordercolor");
}
#setup {
  width: 600px;
  height: 80%;
  left: 30%;
  border-radius: 10px;
  top: 90px;
  // box-shadow: 0px 8px 10px 1px;
}
.chatbox_close {
  position: absolute;
  z-index: 10;
  right: 0;
  top: 0;
  cursor: pointer;
  i {
    font-size: 26px !important;
  }
  &:hover i {
    color: #39f;
  }
}
</style>